"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Explanation_1 = __importDefault(require("../Explanation"));
const common_1 = require("./common");
function ToutesCesConditionsMecanism({ nodeValue, explanation, unit, }) {
    return (jsx_runtime_1.jsx(common_1.Mecanism, Object.assign({ name: "toutes ces conditions", value: nodeValue, unit: unit }, { children: jsx_runtime_1.jsx("ul", { children: explanation.map((item, i) => (jsx_runtime_1.jsx("li", { children: jsx_runtime_1.jsx(Explanation_1.default, { node: item }, void 0) }, i))) }, void 0) }), void 0));
}
exports.default = ToutesCesConditionsMecanism;
